// extracted by mini-css-extract-plugin
export default {"wrapper":"Resume_wrapper__GhIyG","container":"Resume_container__iHt-i"};